'use client';

import { type NodeProps } from '@xyflow/react';
import { NodeShell } from '../BaseNode';
import { NODE_SPECS } from '@/lib/pipeline/registry';
import { usePipelineStore } from '@/lib/pipeline/store';

export default function VideoNode({ id, type, data }: NodeProps) {
  const nodeType = type as string;
  const spec = NODE_SPECS[nodeType];
  const update = usePipelineStore((s) => s.updateNodeData);
  const rt = usePipelineStore((s) => s.runtime[id]);
  const out = rt?.output as { video?: string; _info?: string; _ms?: number } | undefined;
  const d = data as Record<string, unknown>;

  return (
    <NodeShell id={id} type={nodeType}>
      {spec?.params?.map((p) =>
        p.kind === 'number' ? (
          <label key={p.key} className="text-[11px] text-[var(--text-muted)] block">
            {p.label}
            <input
              type="number"
              className="input nodrag w-full text-xs mt-0.5"
              min={p.min}
              max={p.max}
              step={p.step}
              value={(d[p.key] as number | undefined) ?? ''}
              onChange={(e) =>
                update(id, { [p.key]: e.target.value === '' ? null : Number(e.target.value) })
              }
            />
          </label>
        ) : null,
      )}

      {out?.video ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video src={out.video} controls className="rounded-lg w-full mt-1 nodrag" />
      ) : (
        <div className="text-[11px] text-[var(--text-muted)] py-3 text-center">
          Connect an Image + Motion prompt. Runs on the server (Run mode → server).
        </div>
      )}
      {out?._info && <div className="text-[10px] text-[var(--text-muted)] mt-1">{out._info}</div>}
      {out?._ms != null && (
        <div className="text-[10px] text-[var(--text-muted)]">{Math.round(out._ms)}ms</div>
      )}
    </NodeShell>
  );
}
